<template>
  <span> Expira em {{ pad(minutes.toString(), 2) }}:{{ pad(seconds.toString(), 2) }} </span>
</template>

<script setup lang="ts">
import { pad } from "@/filters";
import { ref, computed, onMounted, onBeforeUnmount } from "vue";

interface Props {
  timer: number;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  stop: [];
}>();

const counter = ref(0);
const interval = ref<ReturnType<typeof setInterval> | null>(null);

const minutes = computed(() => Math.floor(counter.value / 60));
const seconds = computed(() => Math.floor(counter.value % 60));

function start() {
  interval.value = setInterval(decrease, 1000);
}

function decrease() {
  counter.value -= 1;

  if (counter.value <= 0) {
    if (interval.value !== null) {
      clearInterval(interval.value);
    }

    emit("stop");
  }
}

onMounted(() => {
  counter.value = props.timer;
  start();
});

onBeforeUnmount(() => {
  if (interval.value !== null) {
    clearInterval(interval.value);
  }
});
</script>
